import React from 'react';
import { IconArrowRight } from '@tabler/icons-react';

const KinPartnership = () => {
  const backgroundImage = 'kin/assest/about/place2.webp';

  const goWa = () => {
    const wa = '6288293734275';
    const waNumber = wa.replace(/\D/g, '');
    const waMessage =
      'Halo KiN Space, saya tertarik untuk kolaborasi/partnership. Boleh minta informasi lebih lanjut?';
    const message = encodeURIComponent(waMessage);
    const whatsappUrl = `https://wa.me/${waNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section id="kinpartnership" aria-labelledby="kinpartnership-title" className="relative">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <div
          className="relative overflow-hidden rounded-3xl bg-cover bg-center"
          style={{ backgroundImage: `url(${backgroundImage})` }}>
          <div className="absolute inset-0 bg-black/45"></div>
          <div className="absolute inset-0 bg-gradient-to-br from-black/50 via-black/65 to-black/55"></div>
          <div className="absolute inset-0 backdrop-blur-[1px]"></div>

          <div className="relative z-10 grid items-start gap-6 px-5 py-6 sm:gap-8 sm:px-8 sm:py-8 md:grid-cols-3 md:px-12 md:py-10 lg:px-16 lg:py-12">
            <div className="md:col-span-1">
              <h2 className="text-2xl font-bold leading-tight tracking-tight text-white drop-shadow-sm sm:text-3xl">
                Open for Partnership
              </h2>
            </div>

            <div className="space-y-5 md:col-span-2 md:space-y-7">
              <p className="text-sm font-semibold leading-relaxed text-white/95 drop-shadow-sm sm:text-base">
                KiN Space is open to diverse forms of collaboration and partnership across
                disciplines. We welcome opportunities to co-create classes both within and beyond
                KiN Space, as well as to develop interactive exhibitions and educational programs.
              </p>

              <p className="text-sm font-semibold leading-relaxed text-white drop-shadow-sm sm:text-base">
                KiN Space serves as a platform for ideas, practices, and experimentation that foster
                participatory learning. We believe collaboration is essential to creating meaningful
                and impactful experiences for wider communities.
              </p>

              <div className="flex justify-start">
                <button
                  onClick={goWa}
                  className="inline-flex w-full items-center justify-center gap-2 rounded-2xl border border-primary-main/60 bg-primary-main px-5 py-3 text-sm font-bold text-white backdrop-blur-sm transition-all hover:bg-primary-dark hover:text-white sm:w-max sm:justify-start sm:py-2.5">
                  Book Partnership Inquiry
                  <IconArrowRight aria-hidden className="h-4 w-4 text-white" stroke={2.5} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KinPartnership;
